angular.module('env.loading.loadingMixin', [])

    .factory('LoadingMixin', function ($q) {

        // Ensuring component loaded mixin. Useful for components with promise-based initialization

        // Inside of your component:
        // Call start() when you begin init your component
        // Call finish() or drop() when loading is complete or fail

        // On depending component:
        // Use promise returned from ensureLoaded().
        // This promise will be resolved only AFTER finish() call.
        // This promise will be rejected only after drop() call.
        function LoadingMixin() {

            var _isLoading = true;
            var _isDropped = false;
            var _loadingDeferred = $q.defer();

            /**
             * Start loading
             */
            function start() {
                _isLoading = true;
                _isDropped = false;
            }

            /**
             * Successfully finish loading
             */
            function finish() {
                _isLoading = false;
                _isDropped = false;
                _loadingDeferred.resolve();
                _loadingDeferred = $q.defer();
            }

            /**
             * Drop loading process (Existing ensureLoaded promises will be rejected)
             */
            function drop() {
                _isLoading = false;
                _isDropped = true;
                _loadingDeferred.reject();
                _loadingDeferred = $q.defer();
            }

            /**
             * Get promise that will be resolved only after finish() method call
             * @returns {*}
             */
            function ensureLoaded() {
                if (!_isLoading) {
                    if (_isDropped) {
                        return $q.reject(false);
                    } else {
                        return $q.when(true);
                    }
                }
                return _loadingDeferred.promise;
            }

            /**
             * Is module still loading
             * @returns {boolean}
             */
            function isLoading() {
                return !!_isLoading;
            }

            this.loading = {
                isLoading: isLoading,
                start: start,
                finish: finish,
                drop: drop,
                ensureLoaded: ensureLoaded
            };
        }

        return (LoadingMixin);
    });